import { createReducer } from '@reduxjs/toolkit';

import { IAppState } from 'app/models';
import { progress, complete } from './actions';

const defaults: IAppState = {
  running: [],
};

export { progress, complete } from './actions';
export { isRunning } from './selectors';

export default createReducer(defaults, (builder) => {
  builder.addCase(progress, (state, { payload }) => ({ ...state,
    running: [...state.running, payload].filter((o, i, a) => a.indexOf(o) === i),
  }));
  builder.addCase(complete, (state, { payload }) => ({ ...state,
    running: state.running.filter(o => o !== payload),
  }));
});
